import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "revision-container p-2" }
const _hoisted_2 = { class: "text-secondary" }
const _hoisted_3 = { class: "list-group list-group-flush" }

import { computed } from 'vue'
import ExamRevision from '../../api/v2/models/exam_revision'
import RevisionItemComponent from './RevisionItemComponent.vue'
import { format } from 'date-fns'
import { uniq } from 'lodash'
import { qEditorState } from '../stores'


export default /*@__PURE__*/_defineComponent({
  __name: 'RevisionComponent',
  setup(__props) {

const examRevisions = computed(() => qEditorState.examRevisions)
const currentExamRevision = computed(() => qEditorState.currentExamRevision)

const examRevisionGroups = computed<{
  date: string
  examRevisions: ExamRevision[]
}[]>(() => {
  const examRevisionsDate = uniq(
    examRevisions.value.map((item) => {
      return format(new Date(item.createdAt), 'MM/dd/yyyy')
    })
  )

  return examRevisionsDate.map((item) => {
    return {
      date: item,
      examRevisions: examRevisions.value.filter((examRevision) => format(new Date(examRevision.createdAt), 'MM/dd/yyyy') == item)
    }
  })
})

const setExamRevision = () => {
  qEditorState.setExamRevision()
}

return (_ctx: any,_cache: any) => {
  const _component_v_expansion_panel_title = _resolveComponent("v-expansion-panel-title")!
  const _component_v_expansion_panel_text = _resolveComponent("v-expansion-panel-text")!
  const _component_v_expansion_panel = _resolveComponent("v-expansion-panel")!
  const _component_v_expansion_panels = _resolveComponent("v-expansion-panels")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[0] || (_cache[0] = _createElementVNode("p", { class: "ms-2 fw-bold" }, "ヒストリー", -1 /* CACHED */)),
    (currentExamRevision.value)
      ? (_openBlock(), _createElementBlock("button", {
          key: 0,
          type: "button",
          onClick: setExamRevision,
          class: "btn btn-sm btn-outline-success revision-btn me-2 mb-2"
        }, " このリビジョンに戻す "))
      : _createCommentVNode("v-if", true),
    _createVNode(_component_v_expansion_panels, null, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(examRevisionGroups.value, (examRevisionGroup, i) => {
          return (_openBlock(), _createBlock(_component_v_expansion_panel, { key: i }, {
            default: _withCtx(() => [
              _createVNode(_component_v_expansion_panel_title, null, {
                default: _withCtx(() => [
                  _createElementVNode("p", _hoisted_2, _toDisplayString(examRevisionGroup.date) + "(" + _toDisplayString(examRevisionGroup.examRevisions.length) + "回) ", 1 /* TEXT */)
                ]),
                _: 2 /* DYNAMIC */
              }, 1024 /* DYNAMIC_SLOTS */),
              _createVNode(_component_v_expansion_panel_text, null, {
                default: _withCtx(() => [
                  _createElementVNode("ul", _hoisted_3, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(examRevisionGroup.examRevisions, (examRevision, j) => {
                      return (_openBlock(), _createBlock(RevisionItemComponent, {
                        examRevision: examRevision,
                        key: j
                      }, null, 8 /* PROPS */, ["examRevision"]))
                    }), 128 /* KEYED_FRAGMENT */))
                  ])
                ]),
                _: 2 /* DYNAMIC */
              }, 1024 /* DYNAMIC_SLOTS */)
            ]),
            _: 2 /* DYNAMIC */
          }, 1024 /* DYNAMIC_SLOTS */))
        }), 128 /* KEYED_FRAGMENT */))
      ]),
      _: 1 /* STABLE */
    })
  ]))
}
}

})